import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { ScientificNumberInput } from '@instructure/quiz-number-input';
import { Decimal } from '@instructure/quiz-i18n';
import { ItemBodyWrapper, RichContentRenderer } from '@instructure/quiz-rce';
import { View } from '@instructure/ui-view';
import t from '@instructure/quiz-i18n/es/format-message';
import { Text } from '@instructure/ui-text';
import { ApplyLocaleContext } from '@instructure/ui-i18n';

/**
---
category: Numeric
---
  Numeric Take component

  ```jsx_example
  function Example (props) {
    const exampleProps = {
      itemBody: 'x is an integer and 9 < x^2 < 99. What\'s the max value of x, minus the minimum value of x',
      userResponse: { value: '18' }
    }

    return (
      <NumericTake {...exampleProps} {...props} />
    )
  }

  <SettingsSwitcher locales={LOCALES}>
    <TakeStateProvider>
      <Example />
    </TakeStateProvider>
  </SettingsSwitcher>
  ```
**/
var invalidMessage = {
  text: t('Answer must be a number. Remove any symbols or units.'),
  type: 'error'
};
var NumericTake = /*#__PURE__*/function (_Component) {
  function NumericTake(props, context) {
    var _this;
    _classCallCheck(this, NumericTake);
    _this = _callSuper(this, NumericTake, [props]);
    _defineProperty(_this, "checkInvalid", function (value, normalized) {
      var warn = _this.props.displayValidationWarning;
      if (warn && value && normalized == null) {
        _this.setState({
          messages: [invalidMessage]
        });
      }
    });
    _defineProperty(_this, "checkInvalidOnce", function () {
      var checked = false;
      return function (value, normalized) {
        if (!checked) {
          checked = true;
          _this.checkInvalid(value, normalized);
          if (_this.props.displayValidationWarning && value && normalized == null) {
            var update = normalized == null ? value : normalized;
            _this.props.handleResponseUpdate(update, null, true);
          }
        }
      };
    });
    _defineProperty(_this, "setNormalized", function (normalized) {
      _this.setState({
        normalized: normalized
      }, function () {
        _this.markInvalidOnMount(_this.state.value, normalized);
      });
    });
    _defineProperty(_this, "handleResponseChange", function (e, value, normalized) {
      _this.setState({
        value: value,
        normalized: normalized,
        messages: []
      });
      _this.updateLogs(value, normalized);
    });
    _defineProperty(_this, "handleResponseBlur", function () {
      var _this$state = _this.state,
        value = _this$state.value,
        normalized = _this$state.normalized;
      _this.checkInvalid(value, normalized);
      _this.updateLogs(value, normalized);
    });
    _defineProperty(_this, "updateLogs", function (value, normalized) {
      // If the response isn't a number, call the handler with the raw response
      var invalid = _this.props.displayValidationWarning && value && normalized == null;
      var update = normalized == null ? value : normalized;
      if (update !== _this.props.userResponse.value) {
        _this.props.handleResponseUpdate(update, null, invalid);
      }
    });
    _this.state = {
      value: Decimal.toLocaleStringIfValid(props.userResponse.value, context.locale)
    };
    _this.markInvalidOnMount = _this.checkInvalidOnce();
    return _this;
  }
  _inherits(NumericTake, _Component);
  return _createClass(NumericTake, [{
    key: "render",
    value: function render() {
      var itemBody = this.props.itemBody;
      return /*#__PURE__*/React.createElement(ItemBodyWrapper, {
        itemBody: itemBody
      }, /*#__PURE__*/React.createElement("div", {
        className: "fs-mask"
      }, /*#__PURE__*/React.createElement(ScientificNumberInput, {
        inputType: "text",
        messages: this.state.messages,
        renderLabel: /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
          "aria-hidden": true
        }, t('Answer')), /*#__PURE__*/React.createElement(ScreenReaderContent, null, /*#__PURE__*/React.createElement(RichContentRenderer, {
          content: this.props.itemBody
        }))),
        onChange: this.handleResponseChange,
        onBlur: this.handleResponseBlur,
        value: this.state.value,
        onInitialNormalization: this.setNormalized,
        autoComplete: "off"
      })));
    }
  }]);
}(Component);
_defineProperty(NumericTake, "propTypes", {
  displayValidationWarning: PropTypes.bool,
  itemBody: PropTypes.string.isRequired,
  handleResponseUpdate: PropTypes.func.isRequired,
  userResponse: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
});
_defineProperty(NumericTake, "contextType", ApplyLocaleContext);
_defineProperty(NumericTake, "defaultProps", {
  displayValidationWarning: false,
  userResponse: {
    value: null
  }
});
export { NumericTake as default };